import React, { useEffect, useState } from "react";
import {
	convertDateFormat,
	getBlogTeaser,
} from "../../Transformations/NewsList";
import "./blog.css";
import LogoLoad from "../../../images/logo/logo-loader.svg";
import { Link } from "react-router-dom";

export default function Blog() {
	const [blogTeasers, setBlogTeasers] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getBlogTeaser();
			setBlogTeasers(data);
		};
		fetchData();
	}, []);
	return (
		<>
			<div className="mx-auto w-75 col-md-12 row">
				<div className="blog_hd col-md-12">
					<h1>Blog</h1>
				</div>
				{blogTeasers ? (
					<div className="justify-content-between col-md-12 row">
						{blogTeasers.map((blog, index) => (
							<Link
								key={index}
								to={"/unternehmen/blog/" + blog.id}
								className="col-md-5 g-1"
							>
								<div className="blog-card" key={blog.id}>
									<div className="cover-image">
										<img src={blog.blog_image} />
									</div>
									<div className="teaser-text">
										<small className="date">
											{convertDateFormat(blog.blog_date)}
										</small>
										<h2 className="title">{blog.blog_hd}</h2>
										<p className="blog-teaser">{blog.blog_teaser}</p>
									</div>
								</div>
							</Link>
						))}
					</div>
				) : (
					<div className="loading-page">
						<div className="loader"></div>
						<img className="load-img" src={LogoLoad} alt="Loading" />
					</div>
				)}
			</div>
		</>
	);
}
